import { InputSchemaType, TriggerAccountInputModalConfiguration } from 'dashboard/models/trigger';
import { WorkflowStatus } from 'dashboard/models/workflow';
import { ApiModel, ApiRelationship, ApiResource } from 'lib/interfaces/api';

export interface AccountActionAttributes {
  name: string;
  status: WorkflowStatus;
  'created-at': string;
  'updated-at': string;
  'archived-at'?: string;
}

export interface AccountActionRelationships {
  workflow?: ApiRelationship<ApiModel.Workflow>;
  'latest-draft-version'?: ApiRelationship<ApiModel.WorkflowVersion>;
  'latest-published-version'?: ApiRelationship<ApiModel.WorkflowVersion>;
}

export type AccountAction = ApiResource<
  AccountActionAttributes,
  AccountActionRelationships,
  ApiModel.AccountAction
>;

export const SAMPLE_TRIGGER_PARAMS_CONFIGURATION: TriggerAccountInputModalConfiguration[] = [
  {
    key: 'sample_input',
    label: 'Sample input',
    type: InputSchemaType.Input,
    placeholder: 'Input',
    required: '{{ false }}',
    hidden: '{{ false }}',
    disabled: '{{ false }}',
  },
  {
    key: 'sample_age',
    label: 'Sample age',
    type: InputSchemaType.Input,
    placeholder: 'Age',
    hidden: '{{ false }}',
    required: '{{ false }}',
    disabled: '{{ !triggerParams.sample_input }}',
  },
  {
    key: 'sample_date',
    label: 'Sample date',
    type: InputSchemaType.Date,
    placeholder: undefined,
    hidden: '{{ triggerParams.sample_age > 18 }}',
    required: '{{ false }}',
    disabled: '{{ false }}',
  },
];
